<script setup >
import {computed} from 'vue';
import {useCrudConverters} from "#imports";

const { uploadFilenameToUrl } = useCrudConverters();
const props = defineProps({
  filename: String || null,
  fallback: String || null,
  size: {
    type: Number,
    default: 20,
  },
  imageSize: {
    type: String,
    default: 'thumbnail',
  }
});

const fallbackStyle = computed(() => {
  // ~0.4× the diameter (not half) so two wide letters (e.g. "MW") fit inside
  // the circle instead of overflowing; lighter weight keeps them narrower.
  return {
    fontSize: Math.round(props.size * 0.4) + 'px',
    fontWeight: 600,
    lineHeight: 1,
  };
});

</script>

<template>
  <v-avatar class="bg-primary text-white font-weight-bold d-flex align-center" :size="size">
    <v-img aspect-ratio="1" :max-height="size" class="ma-0" :height="size" :width="size" :cover="true" v-if="filename" :src="uploadFilenameToUrl(filename, imageSize)"/>
    <span v-else-if="fallback" :style="fallbackStyle" >{{ fallback }}</span>
    <v-icon :size="Math.round(props.size/2)" v-else>mdi-account</v-icon>
  </v-avatar>
</template>

<style>
  .v-avatar .v-responsive {

  }
</style>
